__webpack_require__.p = "/cards-against-containers/";